import { ApiFormattedResponse } from "@models/api_formatted_response"
import { mutate, query } from "@utils/graphql"
import {
  DeleteEmailAdminLogsInput,
  DeleteEmailAdminLogsResponse,
  EmailAdminLogsResponse,
  GetEmailAdminLogsInput
} from "__generated__/graphql"
import deleteEmailAdminLogs from "__generated__/queries/mutations/deleteEmailAdminLogs"
import getEmailAdminLogs from "__generated__/queries/queries/getEmailAdminLogs"

export async function listEmailAdminLogsQuery(
  params: GetEmailAdminLogsInput
): Promise<ApiFormattedResponse<EmailAdminLogsResponse["data"]>> {
  const response = await query<{
    getEmailAdminLogs?: EmailAdminLogsResponse
  }>({
    query: getEmailAdminLogs,
    variables: {
      params
    }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    isSuccess: true,
    data: response?.data?.getEmailAdminLogs?.data
  }
}

export async function deleteEmailAdminLogsMutation(
  params: DeleteEmailAdminLogsInput
): Promise<ApiFormattedResponse<DeleteEmailAdminLogsResponse["data"]>> {
  const response = await mutate<{
    deleteEmailAdminLogs?: DeleteEmailAdminLogsResponse
  }>({
    mutation: deleteEmailAdminLogs,
    variables: {
      params
    }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    isSuccess: true,
    data: response?.data?.deleteEmailAdminLogs?.data
  }
}
